import type { UseFormReturn } from 'react-hook-form';
import type { BookingFormData } from '@geely/shared';
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Input,
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@geely/ui';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { MaskedPhoneInput } from '@/app/components/booking/MaskedPhoneInput';
import { MaskedEmailInput } from '@/app/components/booking/MaskedEmailInput';
import { MaskedCpfInput } from '@/app/components/booking/MaskedCpfInput';

interface PersonalInfoStepProps {
  form: UseFormReturn<BookingFormData>;
  onBack: () => void;
  onNext: () => void;
}

export function PersonalInfoStep({ form, onBack, onNext }: PersonalInfoStepProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Informações Pessoais</CardTitle>
        <CardDescription>Preencha seus dados para contato</CardDescription>
      </CardHeader>
      <CardContent>
        <Form {...form}>
          <div className="space-y-4">
            <FormField
              control={form.control}
              name="customerName"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Nome Completo *</FormLabel>
                  <FormControl>
                    <Input
                      {...field}
                      placeholder="Seu nome completo"
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="customerPhone"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Telefone *</FormLabel>
                  <FormControl>
                    <MaskedPhoneInput
                      value={field.value}
                      onChange={field.onChange}
                      name={field.name}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="customerEmail"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Email *</FormLabel>
                  <FormControl>
                    <MaskedEmailInput
                      value={field.value}
                      onChange={field.onChange}
                      name={field.name}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="customerCpf"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>CPF/CNPJ *</FormLabel>
                  <FormControl>
                    <MaskedCpfInput
                      value={field.value}
                      onChange={field.onChange}
                      name={field.name}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <div className="flex justify-between pt-4">
              <Button variant="outline" onClick={onBack}>
                <ArrowLeft className="size-4 mr-2" />
                Voltar
              </Button>
              <Button onClick={onNext}>
                Próximo
                <ArrowRight className="size-4 ml-2" />
              </Button>
            </div>
          </div>
        </Form>
      </CardContent>
    </Card>
  );
}
